export class AccessToken {
  private _clients: string[] | null = null;
  constructor(public readonly raw: string) {
    this._clients = this.parseClients(raw);
  }

  get clients(): string[] | null {
    return this._clients;
  }

  private parseClients(token: string): string[] | null {
    if (!token) return null;
    try {
      const payload = token.split('.')[1];
      if (!payload) return null;
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      const claims = JSON.parse(decoded) as Record<string, unknown>;
      const rawClients = claims['client-id'];
      if (!rawClients) return null;
      if (typeof rawClients === 'string') {
        try {
          const parsed = JSON.parse(rawClients);
          if (Array.isArray(parsed)) return parsed.map(String);
          return [String(rawClients)];
        } catch {
          return [rawClients as string];
        }
      }
      if (Array.isArray(rawClients)) return rawClients.map(String);
      return [String(rawClients)];
    } catch {
      return null;
    }
  }
}
